/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Account Type
 */
export type GetUserResponseAccountType = typeof GetUserResponseAccountType[keyof typeof GetUserResponseAccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserResponseAccountType = {
  PERSONAL: 'PERSONAL',
  CORPORATE: 'CORPORATE',
  COBRAND: 'COBRAND',
} as const;
